import React from 'react';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
export const TextBox = ({text, cohort}: {text: string, cohort?: string}) => {
  const { t } = useTranslation(cohort);
  const displayText = cohort ? t(text) : text;

  return (
    <div style={{
      margin: '1rem 0',
      padding: '1rem',
      background: '#e5e5e5',
      borderRadius: '5px',
      textAlign: 'left'
    }}>
      <Typography>{displayText}</Typography>
    </div>
  );
}
